// ============================================
// Creator State - Situational Images (Zustand 기반)
// 상황별 이미지 상태 관리
// ============================================

import { useCreatorStore, MAX_SITUATIONAL_IMAGES } from '../../../stores/creatorStore.js';

export { MAX_SITUATIONAL_IMAGES };

// Getters
export const getSituationalImages = () => useCreatorStore.getState().situationalImages;
export const getEditingSituationalIndex = () => useCreatorStore.getState().editingSituationalIndex;

// Setters
export function setSituationalImages(images) {
  useCreatorStore.getState().setSituationalImages(images);
}

export function addSituationalImage(image) {
  useCreatorStore.getState().addSituationalImage(image);
}

export function updateSituationalImage(index, image) {
  useCreatorStore.getState().updateSituationalImage(index, image);
}

export function removeSituationalImage(index) {
  useCreatorStore.getState().removeSituationalImage(index);
}

export function setEditingSituationalIndex(index) {
  useCreatorStore.getState().setEditingSituationalIndex(index);
}
